import { z as t } from "zod";
const e = t.object({
  text: t.string().optional(),
  type: t.enum(["text", "file", "button"]),
  status: t.enum(["info", "success", "error", "warning"]).nullable().optional(),
  button_text: t.string().optional(),
  button_redirect_type: t.string().optional(),
  button_url: t.string().optional(),
  resume_product_type: t.string().optional()
}), n = t.object({
  content: t.array(e),
  context: t.enum(["borrower_platform"]).optional(),
  state: t.string().optional(),
  version: t.string()
}), o = t.object({
  id: t.number(),
  first_name: t.string(),
  last_name: t.string().nullable(),
  email: t.email(),
  phone: t.string().nullable(),
  created_at: t.iso.datetime({ offset: !0 })
}), i = t.object({
  id: t.string(),
  content: n,
  is_resolved: t.boolean(),
  resolved_by: o.nullable().optional(),
  resolved_at: t.string().nullable().optional(),
  is_shared_with_borrower: t.boolean().optional(),
  commentable_type: t.string(),
  commentable_id: t.union([t.string(), t.number()]),
  created_at: t.string()
});
export {
  i as commentSchema,
  n as messageSchema
};
